import ProjectTree from './ProjectTree';

export { default as useProjectTree, PROJECT_TREE_QUERY } from './useProjectTree';

export default ProjectTree;
